import React from "react";
import Header1 from "./ptfHeader";

const PrivacyPolicy = () => {
  return (
    <div>
      <Header1 />
      {/* <div className="max-w-4xl mx-auto px-4 mt-28 mb-16"> */}
      <div className="container mx-auto mt-28 mb-16 px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-gray-500 mb-12">
            Your privacy matters to{" "}
            <span className="font-semibold bg-gradient-to-r from-blue-600 to-cyan-400 bg-clip-text text-transparent">
              MyCafe Connect
            </span>
            .
          </p>
        </div>

        {/* Introduction */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="text-gray-600 leading-relaxed">
            We are committed to safeguarding your privacy while you interact
            with the content, features, products, and services available through{" "}
            <span className="font-semibold bg-gradient-to-r from-blue-600 to-cyan-400 bg-clip-text text-transparent">
              MyCafe Connect
            </span>
            . This Privacy Policy explains how we collect, use, and protect your
            information.
          </div>
        </div>

        {/* Scope */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="font-semibold text-lg mb-2">1. Scope of Policy</div>
          <div className="text-gray-600 leading-relaxed">
            This Privacy Policy applies exclusively to this mobile application
            and does not extend to external websites or services linked within
            the app. By using this app, you consent to the practices described
            herein.
          </div>
        </div>

        {/* Information We Collect */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="font-semibold text-lg mb-2">
            2. Information We Collect
          </div>
          <div className="text-gray-600 leading-relaxed">
            We collect two categories of information:
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>
                <strong>Information You Voluntarily Provide</strong> (e.g.,
                registration, communication).
              </li>
              <li>
                <strong>Information Collected Automatically</strong> (e.g.,
                cookies, analytics, usage tracking).
              </li>
            </ul>
            All collected data is handled with strict confidentiality.
          </div>
        </div>

        {/* Registration Info */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="font-semibold text-lg mb-2">
            3. Voluntary Registration Information
          </div>
          <div className="text-gray-600 leading-relaxed">
            When registering with{" "}
            <span className="font-semibold bg-gradient-to-r from-blue-600 to-cyan-400 bg-clip-text text-transparent">
              MyCafe Connect
            </span>
            , we may collect personal details such as name, email address, phone
            number, and address. This information is collected only when
            voluntarily provided and is used to enhance your experience and
            service delivery.
          </div>
        </div>

        {/* Additional Info */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="font-semibold text-lg mb-2">
            4. Additional Information for Services
          </div>
          <div className="text-gray-600 leading-relaxed">
            We may collect additional information when you:
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Make purchases</li>
              <li>Opt in for promotional emails or SMS notifications</li>
              <li>Scan QR codes using your device camera</li>
            </ul>
            This may include billing details, contact information, and payment
            data.
          </div>
        </div>

        {/* Cookies */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="font-semibold text-lg mb-2">
            5. Cookies & Tracking Technologies
          </div>
          <div className="text-gray-600 leading-relaxed">
            <span className="font-semibold bg-gradient-to-r from-blue-600 to-cyan-400 bg-clip-text text-transparent">
              MyCafe Connect
            </span>{" "}
            uses cookies and similar technologies to improve user experience,
            maintain secure sessions, and remember preferences. Cookies may
            expire after inactivity to maintain security. You may manage cookie
            preferences through your browser settings.
          </div>
        </div>

        {/* Third Party */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="font-semibold text-lg mb-2">
            6. Third-Party Cookies
          </div>
          <div className="text-gray-600 leading-relaxed">
            Third-party service providers or advertisers may use cookies to
            deliver relevant advertisements or analyze usage data. These
            third-party cookies are not controlled by{" "}
            <span className="font-semibold bg-gradient-to-r from-blue-600 to-cyan-400 bg-clip-text text-transparent">
              MyCafe Connect
            </span>
            .
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
